import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { noticeStore } from '../stores'
import { SubHeaderComponent } from './sub-header'
import * as bookmark from '../bookmark'
import { PublisherDisplayStr, PublisherStr } from '../../../common/define'

@observer
export class BookmarksComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      cachedPosts: bookmark.list(),
      activeTab: 'export',
      exportedText: '',
      importInput: '',
      message: '',
    }
  }

  // notify 는 성공 등 non-critical 피드백을 토스트로 알린다 (모달 유지 대신 — 모달 UX 관행).
  notify(message, status) {
    if (window.UIkit && window.UIkit.notification) {
      window.UIkit.notification({ message, status, pos: 'top-center', timeout: 3000 })
    }
  }

  closeModal() {
    if (window.UIkit && window.UIkit.modal) {
      const modal = window.UIkit.modal('#bookmark-io-modal')
      if (modal) {
        modal.hide()
      }
    }
  }

  async onExport() {
    const text = bookmark.exportText()
    try {
      await navigator.clipboard.writeText(text)
      // 성공: 토스트로 알리고 모달을 닫는다. 긴 JSON 은 상시 노출하지 않는다.
      this.setState({ exportedText: '', message: '' })
      this.notify('클립보드에 복사됐습니다. 다른 기기의 다시보기에서 붙여넣으세요', 'success')
      this.closeModal()
    } catch (e) {
      // 실패: fallback 으로 텍스트를 노출해 수동 복사하게 하고 모달을 유지한다.
      this.setState({
        exportedText: text,
        message: '자동 복사에 실패했습니다. 아래 텍스트를 길게 눌러 직접 복사하세요',
      })
    }
  }

  onImport() {
    const text = (this.state.importInput || '').trim()
    if (!text) {
      this.setState({ message: '가져올 목록 텍스트를 붙여넣으세요' })
      return
    }
    try {
      const added = bookmark.importText(text)
      // 성공: 목록을 갱신하고 토스트로 결과를 알린 뒤 모달을 닫는다 (뒤 목록에 즉시 반영됨).
      this.setState({ cachedPosts: bookmark.list(), importInput: '', message: '' })
      this.notify(0 < added ? `${added}개 가져왔습니다` : '새로 추가된 글이 없습니다 (모두 중복)', 'success')
      this.closeModal()
    } catch (e) {
      // 실패: 모달을 유지하고 에러를 인라인으로 표시해 수정·재시도하게 한다.
      this.setState({ message: `가져오기 실패: ${e.message}` })
    }
  }

  render() {
    return (
      <div id="notices">
        <SubHeaderComponent isBookmark={true} />

        <div className="uk-flex uk-flex-right uk-margin-small-top uk-margin-small-bottom">
          <button className="uk-button uk-button-text uk-text-small" type="button" uk-toggle="target: #bookmark-io-modal">
            <span uk-icon="icon: settings; ratio: 0.8" className="uk-margin-small-right" />내보내기·가져오기
          </button>
        </div>

        <ul className="uk-list uk-list-divider uk-text-middle">
          {
            this.state.cachedPosts.map((post, i) =>
              <li data-post-id={i} className="post" key={i}>
                <BookmarkComponent post={post} postIndex={i} />
              </li>)
          }
          {
            this.state.cachedPosts.length <= 0 &&
            <div className="uk-text-center uk-margin"> no data </div>
          }
        </ul>
        {
          noticeStore.notices.length <= 0 &&
          <div className="uk-text-center uk-margin">
            no notice
        </div>
        }

        <div id="bookmark-io-modal" uk-modal="uk-modal">
          <div className="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
            <button className="uk-modal-close-default" type="button" uk-close="uk-close" />
            <h3 className="uk-modal-title">다시보기 목록 관리</h3>

            {/* 탭 활성은 React state 로 제어 — uk-tab 속성을 붙이면 UIkit 이 리렌더된 uk-active 를 덮어써 충돌하므로 className 은 스타일 용도로만 둔다 */}
            <ul className="uk-tab">
              <li className={this.state.activeTab === 'export' ? 'uk-active' : ''}>
                <a href="#" onClick={e => { e.preventDefault(); this.setState({ activeTab: 'export', message: '' }) }}>내보내기</a>
              </li>
              <li className={this.state.activeTab === 'import' ? 'uk-active' : ''}>
                <a href="#" onClick={e => { e.preventDefault(); this.setState({ activeTab: 'import', message: '' }) }}>가져오기</a>
              </li>
            </ul>

            {
              this.state.activeTab === 'export' ?
                <div>
                  <p className="uk-text-small uk-text-muted">지금 목록을 복사해 다른 기기·브라우저로 옮깁니다</p>
                  <button className="uk-button uk-button-small uk-button-primary" type="button" onClick={() => this.onExport()}>클립보드에 복사</button>
                  {
                    this.state.exportedText &&
                    <textarea className="uk-textarea uk-margin-small" readOnly rows={5} value={this.state.exportedText} onFocus={e => e.target.select()} />
                  }
                </div>
                :
                <div>
                  <p className="uk-text-small uk-text-muted">다른 기기에서 내보낸 텍스트를 붙여넣고 가져오기를 누르세요</p>
                  <textarea className="uk-textarea uk-margin-small" rows={5}
                    placeholder="여기에 붙여넣기"
                    value={this.state.importInput}
                    onChange={e => this.setState({ importInput: e.target.value })} />
                  <div>
                    <button className="uk-button uk-button-small uk-button-primary" type="button" onClick={() => this.onImport()}>가져오기</button>
                  </div>
                </div>
            }

            {
              this.state.message &&
              <div className="uk-alert uk-alert-primary uk-text-small uk-margin-top" style={{ padding: '0.6em 1em' }}>{this.state.message}</div>
            }
          </div>
        </div>
      </div>
    );
  }
}

@observer
export class BookmarkComponent extends Component {
  get isBookmarked() {
    return 0 <= bookmark.getIndex(this.props.post)
  }

  async onBookmark() {
    console.log('on bookmark', { post: this.props.post })
    if (bookmark.has(this.props.post)) {
      bookmark.del(this.props.post)
    } else {
      bookmark.add(this.props.post)
    }
  }
  render() {
    return (
      <div className="uk-flex uk-flex-middle">
        <a
          className="post-body uk-link-text uk-text-truncate uk-text-normal"
          href={this.props.post.url}
          style={{ flexGrow: 1 }}>
          {this.props.post.subject}
        </a>
        <a
          className={`bookmark-icon ${bookmark.has(this.props.post) ? 'bookmarked' : 'not-bookmarked'} uk-icon-button uk-text-light uk-text-center uk-text-middle`}
          uk-icon="bookmark"
          style={{ flexShrink: 0, width: '2em', height: '2em' }}
          onClick={() => this.onBookmark()} />
        <span
          className={`badge-${PublisherStr[this.props.post.publisher]} uk-badge uk-text-nowrap uk-text-small uk-text-light`}
          style={{ marginLeft: '0.2em', flexShrink: 0 }} >
          {PublisherDisplayStr[this.props.post.publisher]}
        </span>
      </div>
    )
  }
}
